









































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import http from "@/http/axios";
import { has_value } from "@/utils/app-util";


@Component
export default class LineLogin extends Vue {
  private email = "";
  private pass = "";
  private snackbar = false;
  private error = false;
  private text = "No Response";
  private loading = false;
  private valid = true;


  created() {
    const timestamp = Number(this.$router.currentRoute.query.timestamp?this.$router.currentRoute.query.timestamp:0);
    if ((Math.floor(new Date().getTime()/1000) - timestamp) > 10 * 60){
        this.$router.push({
            name: `ErrorPage`,
        });
    }
  }

  async destroyed() {
    await this.clearLogin();
  }


  public async login() {
    this.loading = true;
    // this.$Progress.start();
    const params = {
      email: this.email,
      password: this.pass
    };
    const result = await http.post("/auth/line/link", params);
    if (result) {
      if (result.data.status === "Success") {
        // Login Successful
        
        const data = result.data.data;
        if (has_value(data['nonce'])){
            window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$router.currentRoute.query.linkToken}&nonce=${data['nonce']}`;
        }
        else{
            // Server Failed
            this.error = true;
            this.text = "Missing Nonce.";
            console.log(`Server Failed`);
        }
        
      } else {
        // Login Failed
        this.error = true;
        this.text = result.data.message;
        console.log(`Login Failed`);
      }
    } else {
      this.error = true;
      this.text = "No Response";
      console.log(`error`);
    }
    this.loading = false;
  }

  clearLogin() {
    this.email = "";
    this.pass = "";
  }
}
